// Stroke icons for the patient-facing connection status. They inherit
// `currentColor`, so each state sets its colour on the icon's own text colour,
// and they are always decorative — the text next to them carries the meaning.
const StrokeIcon = ({ children, strokeWidth = 2, ...props }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
    focusable="false"
    {...props}
  >
    {children}
  </svg>
);

export const ReconnectIcon = props => (
  <StrokeIcon {...props}>
    <path d="M21 12a9 9 0 1 1-2.64-6.36" />
    <path d="M21 3v6h-6" />
  </StrokeIcon>
);

export const RestoredIcon = props => (
  <StrokeIcon strokeWidth={2.2} {...props}>
    <circle cx="12" cy="12" r="9" />
    <path d="m8 12 3 3 5-6" />
  </StrokeIcon>
);

export const CheckIcon = props => (
  <StrokeIcon strokeWidth={2.4} {...props}>
    <path d="m6 12 4 4 8-9" />
  </StrokeIcon>
);

export const AlertIcon = props => (
  <StrokeIcon {...props}>
    <path d="M12 3 2 20h20Z" />
    <path d="M12 10v4" />
    <path d="M12 17h.01" />
  </StrokeIcon>
);

export const VoiceOffIcon = props => (
  <StrokeIcon {...props}>
    <path d="M11 5 6 9H3v6h3l5 4Z" />
    <path d="m22 9-6 6M16 9l6 6" />
  </StrokeIcon>
);

export const VideoOffIcon = props => (
  <StrokeIcon {...props}>
    <rect x="3" y="6" width="13" height="12" rx="2" />
    <path d="m16 10 5-3v10l-5-3" />
    <path d="M3 3l18 18" />
  </StrokeIcon>
);

export const CameraIcon = props => (
  <StrokeIcon {...props}>
    <path d="M4 8h3l2-3h6l2 3h3v11H4Z" />
    <circle cx="12" cy="13" r="3.5" />
  </StrokeIcon>
);

export const CameraOffIcon = props => (
  <StrokeIcon {...props}>
    <path d="M4 8h3l2-3h6l2 3h3v11H4Z" />
    <path d="M3 3l18 18" />
  </StrokeIcon>
);

export const SignalIcon = props => (
  <StrokeIcon {...props}>
    <path d="M2 9a15 15 0 0 1 20 0" />
    <path d="M5.5 12.5a10 10 0 0 1 13 0" />
    <path d="M9 16a5 5 0 0 1 6 0" />
    <path d="M12 19.5h.01" />
  </StrokeIcon>
);

export const WeakSignalIcon = props => (
  <StrokeIcon {...props}>
    <path d="M2 9a15 15 0 0 1 20 0" opacity="0.3" />
    <path d="M5.5 12.5a10 10 0 0 1 13 0" opacity="0.3" />
    <path d="M9 16a5 5 0 0 1 6 0" />
    <path d="M12 19.5h.01" />
  </StrokeIcon>
);

export const OfflineIcon = props => (
  <StrokeIcon {...props}>
    <path d="M2 9a15 15 0 0 1 4.5-2.9M10 5.1A15 15 0 0 1 22 9" />
    <path d="M5.5 12.5a10 10 0 0 1 3.3-2M15 10.4a10 10 0 0 1 3.5 2.1" />
    <path d="M9 16a5 5 0 0 1 6 0" />
    <path d="M12 19.5h.01" />
    <path d="M3 3l18 18" />
  </StrokeIcon>
);

export const SpinnerIcon = props => (
  <StrokeIcon strokeWidth={2.2} {...props}>
    <path d="M12 3a9 9 0 1 0 9 9" />
  </StrokeIcon>
);

export const CloseIcon = props => (
  <StrokeIcon strokeWidth={2.4} {...props}>
    <path d="M6 6l12 12M18 6 6 18" />
  </StrokeIcon>
);
